import script from "./LangSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./LangSelect.vue?vue&type=script&setup=true&lang=ts"

import "./LangSelect.vue?vue&type=style&index=0&id=3e34f0ec&scoped=true&lang=css"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e34f0ec"]])

export default __exports__